
<template functional>
    <v-tooltip 
        v-bind="((o, keys) => {
                const ta = { ...o };
                // top по умолчанию
                if (ta.top === undefined && ta.bottom === undefined && ta.left === undefined && ta.right === undefined) {
                    ta.top = true;
                }
                return keys.reduce((acc, key) => {
                    acc[key] = ta[key];
                    return acc;
                }, {});
            })(data.attrs, $options.pickKeys)"
        v-if="data.attrs.show !== false"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                v-if="!!listeners.click || !!data.attrs.href || !!data.attrs.to"
                v-on="on"
                :disabled="data.attrs.disabled"
                :href="data.attrs.href"
                :to="data.attrs.to"
                :target="data.attrs.target"
                @[listeners.click?`click`:null]="listeners.click"
                icon
            >
                <v-icon
                    v-bind="((attrs, pickKeys, exceptions) =>
                        Object.keys(attrs)
                            .filter(key => !(pickKeys.includes(key) && !exceptions.includes(key)))
                            .reduce((acc, key) => ((acc[key] = attrs[key]), acc), {})
                        )(data.attrs, $options.pickKeys, $options.iconExceptions)"
                    :class="[data.class, data.staticClass]"
                >
                    {{ data.attrs.icon }}
                </v-icon>
            </v-btn>
            <v-icon
                v-else
                v-bind="((attrs, pickKeys, exceptions) =>
                        Object.keys(attrs)
                            .filter(key => !(pickKeys.includes(key) && !exceptions.includes(key)))
                            .reduce((acc, key) => ((acc[key] = attrs[key]), acc), {})
                        )(data.attrs, $options.pickKeys, $options.iconExceptions)"
                v-on="on"
                :class="[data.class, data.staticClass]"
            >
                {{ data.attrs.icon }}
            </v-icon>
        </template>
        <slot><span v-html="data.attrs.caption"></span></slot>
    </v-tooltip>
</template>

<script>
const PICK_KEYS = [
  'top', 'left', 'right', 'bottom', 'absolute', 'activator', 'attach', 'color',
  'disabled', 'eager', 'tag', 'allow-overflow', 'close-delay', 'content-class',
  'internal-activator', 'max-width', 'min-width', 'nudge-bottom', 'nudge-left',
  'nudge-right', 'nudge-top', 'nudge-width', 'offset-overflow', 'open-delay',
  'open-on-click', 'open-on-focus', 'open-on-hover', 'position-x', 'position-y',
  'z-index','value'
];
const ICON_EXCEPTIONS = ['color', 'disabled'];
export default {
    name: "VIconTooltp",
    functional: true,
    pickKeys: PICK_KEYS,
    iconExceptions: ICON_EXCEPTIONS,
}
</script>
<style scoped lang="scss">

</style>
